// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"4403d83b","845":"ae0c9175"}[chunkId] + ".chunk.js";
};